/**
 * Read-only resolution of which cached MSAL account the "switcher" list should hide.
 * Does not call setActiveAccount (safe during React render).
 */

import { ACTIVE_ACCOUNT_STORAGE_KEY } from './msalConfig';
import { normalizeEmailForMatch, accountMatchesProfileEmail } from './msalAccountDisplay';

/**
 * @param {import('@azure/msal-browser').PublicClientApplication|null|undefined} instance
 * @param {string|null|undefined} profileEmail optional app profile email (e.g. from API)
 * @returns {Record<string, unknown>|null}
 */
export function resolveExcludedAccountForSwitcherList(instance, profileEmail) {
  if (!instance) return null;

  let fromMsal = null;
  try {
    fromMsal = instance.getActiveAccount();
  } catch (_) {}
  if (fromMsal) return fromMsal;

  let all = [];
  try {
    all = instance.getAllAccounts() || [];
  } catch (_) {
    return null;
  }

  let storedId = null;
  try {
    storedId = localStorage.getItem(ACTIVE_ACCOUNT_STORAGE_KEY);
  } catch (_) {
    storedId = null;
  }
  if (storedId) {
    const stored = all.find((a) => a.homeAccountId === storedId);
    if (stored) return stored;
  }

  const normalized = normalizeEmailForMatch(profileEmail);
  if (normalized && all.length > 0) {
    const matches = all.filter((a) => accountMatchesProfileEmail(a, normalized));
    if (matches.length === 1) return matches[0];
  }

  return null;
}
